import { ExportList } from './ExportList'
import { withExportList } from './withExportList'

export const ConnectedExportList = withExportList(ExportList)

export { ConnectedExportList as ExportList }
